import React, { Component } from 'react';
import { connect } from 'react-redux';
import { eapiClient } from '../../../../restClient';
import { Translations } from '../../../../utils';
import Checkbox from '../../../common/Checkbox/Checkbox';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../common/Modal';
import { caseMenuInfo } from '../actions/actionCreator';

class CaseParticipantsListItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sentToRevoke: {},
      minNoOfClientCasesSelected: undefined,
      finalPayload: [],
      revisedPayload: []
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  componentWillMount() {

    let payloadData = this.props.formData;
    let finalData = payloadData.map(item => {
      item.users.map(key => key.checked = false)
      return item
    })

    this.setState({
      finalPayload: finalData
    })
  }

  createPayload = (data) => {
    var finalData = data.map(item => {
      let userIds = [];
      let userName = [];
      let keyItem;
      let responseKeyItem;
      item.users.filter(key => {
        if (key.checked === true) {
          let obj = {};
          obj.name = key.firstName;
          userName.push(obj)
          return userIds.push(key.email)
        }
      })

      if (userIds.length > 0) {
        keyItem = {
          userIds: userIds,
          caseId: item.caseId
        }
        responseKeyItem = {
          userNames: userName,
          entityName: item.entityName
        }
        return {
          keyItem,
          responseKeyItem
        }
      }
    })

    let payload = finalData.filter(key => { return key !== undefined })
    this.props.getChildData(payload);
  }

  _checkSelectedOption = (event) => {
    let parentKey = this.props.parentKey;
    let childKey = this.props.childKey;
    let finalData = this.state.finalPayload;

    finalData[parentKey].users[childKey].checked = event.target.checked

    this.createPayload(finalData)

  }

  casesSelectedForRevoke = (casesToBeCancelled) => {
    return Object.keys(casesToBeCancelled).some(c => casesToBeCancelled[c]);
  }

  render() {
    const firstName = this.props.item.firstName;
    const lastName = this.props.item.lastname !== undefined ? this.props.item.lastname : ''
    return (this.props.customer !== undefined ? (
      <li className="participant-list-item checkbox-container">
        <Checkbox onChange={this._checkSelectedOption}
          name={this.props.item.entityName}
          disabled={this.props.customer.emailAddress === this.props.item.email}
          tabindex="0"
        />
        <label className="gdocs-label-color gdocs-responsive-text">
          {firstName + " " + lastName}
        </label>
      </li>
    ) : '');
  }
}

class CaseParticipantsList extends Component {

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {

    return (
      <li
        className="case-menu__list__item-edit-case"
      >
        {this.props.item}
        <ul className="participant-list-edit-case">
          {
            this.props.users.map((item, key) => <CaseParticipantsListItem
              item={item}
              childKey={key}
              parentKey={this.props.parentIndex}
              formData={this.props.formData}
              getChildData={this.props.getParentData}
              customer={this.props.customer}
            />
            )
          }
        </ul>
      </li>
    )
  }
}

class EditEntityModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      payloadData: [],
      RevoekAccessConfirmationnDialog: false,
      showRevokeAccesModal: true
    }
  }

  getFormSubmitData = (data) => {
    //let finalData = data.map(key => {return key !== undefined})
    this.setState({
      payloadData: data,
      setRevokeaccess: data
    })
  }
  toggleDialog = () => {
    this.setState({ RevoekAccessConfirmationnDialog: false });
  }
  submitForm = () => {
    let setPayLoad = [];
    this.state.payloadData.map(item => {
      setPayLoad.push(item.keyItem);
    })
    eapiClient("/cases/revokeUserAccess", {
      method: 'POST',
      timeout: 30000,
      data: JSON.stringify(setPayLoad)
    })
      .then(({ data, status, headers }) => {
        if (status === 200) {
          this.setState({
            RevoekAccessConfirmationnDialog: true,
            showRevokeAccesModal: false
          });
        }
        eapiClient('/cases/' + this.props._caseId + '/menu')
          .then(({ data }) => {
            //this.props._callback({caseMenu: data.responseData})
            this.props.caseMenuInfo(data.responseData)
            this.props._edit('true');
          });

      })

  }
  submitSowForm = () => {
    let setPayLoad = [];
    let finalPayload = [];
    this.state.payloadData.map(item => {
      setPayLoad.push(item.keyItem);
    })
    let agentDetail = this.props._caseId.filter(entity => {
      return entity.agent
    })
    let finalPayloadObj = setPayLoad[0]
    finalPayloadObj.caseId = agentDetail[0].groupId
    finalPayload.push(finalPayloadObj)
    eapiClient("/sows/revokeSowUserAccess", {
      method: 'POST',
      timeout: 30000,
      data: JSON.stringify(finalPayload)
    })
      .then(({ data, status, headers }) => {
        if (status === 200) {
          this.setState({
            RevoekAccessConfirmationnDialog: true,
            showRevokeAccesModal: false
          });
        }
        eapiClient('/sows/' + agentDetail[0].groupId + '/menu')
          .then(({ data }) => {
            //this.props._callback({caseMenu: data.responseData})
            this.props.caseMenuInfo(data.responseData)
            this.props._edit('true');
          });

      })

  }


  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    if (this.props_ReokeaccessConfrim === true) {
      this.setState({
        RevoekAccessConfirmationnDialog: true,
        showRevokeAccesModal: false
      });
    }
    return (
      <div>
        <Modal
          show={this.state.showRevokeAccesModal}
          onClose={this.props._edit}
        >
          <ModalHeader>
            <div className="gdocs-edit-case-headn">
              {this.translations(this.props._modalRevokedAccessJson.page_title_mainTitle.pageHeading)}
            </div>
            <div className="gdocs-edit-case-desc">
              {this.translations(this.props._modalRevokedAccessJson.page_title_mainTitle.descriptionText)}
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="gdocs-edit-case-entity_parent">
              {
                Object.keys(this.props._entityName).map((_entityName, index) =>
                  Object.keys(this.props._entityName[_entityName].users).length !== 0
                    ? (<div className="gdocs-edit-case-entity-paddn">
                      <div className="gdocs-edit-case-entity gdocs-responsive-text">
                        {this.props._entityName[_entityName].entityName}
                      </div>
                      <CaseParticipantsList
                        item={this.props._entityName[_entityName].entityName}
                        parentIndex={index}
                        users={this.props._entityName[_entityName].users}
                        formData={this.props._entityName}
                        getParentData={this.getFormSubmitData}
                        customer={this.props.customer}
                      />
                    </div>)
                    : ''
                )
              }
            </div>
          </ModalBody>
          <ModalFooter>
            <button onClick={this.props._edit} className="gdocs-btn-cancel">
              {this.translations(this.props._modalRevokedAccessJson.button_cancel.text)}
            </button>
            <button className="gdocs-btn-primary" onClick={this.props.sow ? this.submitSowForm : this.submitForm} disabled={this.state.setRevokeaccess !== undefined ? this.state.setRevokeaccess.length > 0 ? false : true : true}>
              {this.translations(this.props._modalRevokedAccessJson.button_revokeAccess.text)}
            </button>
          </ModalFooter>
        </Modal>

        <RevoekAccessConfirmation
          show={this.state.RevoekAccessConfirmationnDialog}
          formJson={this.props._modalRevokedAccessJson}
          toggleDialog={this.toggleDialog}
          history={this.props.history}
          setRevokeaccess={this.state.setRevokeaccess}
          bsClass="send-to-client-modal-content"
          translations={(word) => this.translations(word)}
          sowEntities={this.props.sowEntities}
          sow={this.props.sow}
        />
      </div>
    );
  }
}

const RevoekAccessConfirmation = (props) => {
  return (
    <Modal
      show={props.show}
      onClose={props.toggleDialog}
    >
      <ModalHeader>
        <div className="gdocs-edit-case-headn">
          {props.translations(props.formJson.static_text_accessRevoked.text)}
        </div>
        <div className="gdocs-edit-case-desc">
          {props.translations(props.formJson.static_text_accessRevoked.description)}
        </div>
      </ModalHeader>
      <ModalBody>
        <div>
          {

            props.sow ? (props.setRevokeaccess !== undefined
              ? props.setRevokeaccess.map(entities => {
                let results = [];
                results.push(
                  <div className="gdocs-edit-case-entity">
                    {props.sowEntities.filter(entity => {
                      return entity.agent
                    })[0].registeredName
                    }
                  </div>
                )
                {
                  entities.responseKeyItem.userNames.map((item, index) => {
                    results.push(<div className="gdocs-label-color gdocs-responsive-text">{item.name}</div>)
                  })
                }
                return results;
              })
              : '') : (props.setRevokeaccess !== undefined
                ? props.setRevokeaccess.map(entities => {
                  let results = [];
                  results.push(
                    <div className="gdocs-edit-case-entity">
                      {entities.responseKeyItem.entityName}
                    </div>
                  )
                  {
                    entities.responseKeyItem.userNames.map((item, index) => {
                      results.push(<div className="gdocs-label-color gdocs-responsive-text">{item.name}</div>)
                    })
                  }
                  return results;
                })
                : '')
          }
        </div>
      </ModalBody>
      <ModalFooter>
        <button className="gdocs-btn-primary" onClick={props.toggleDialog}>
          {props.translations(props.formJson.button_ok.text)}
        </button>
      </ModalFooter>
    </Modal>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    caseMenuInfo: caseMenuData => {
      dispatch(caseMenuInfo(caseMenuData))
    }
  }
}

const mapStateToProps = state => {
  return {
    customer: state.auth.userDetails
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditEntityModal);



// WEBPACK FOOTER //
// ./src/components/common/CaseMenu/EditEntity/index.js